<ng-container [ngSwitch]="formType$ | async">
  <ng-container *ngSwitchCase="enrollmentFormType.CreditCardAndBankAccount">
    <ng-container *ngTemplateOutlet="creditCardAndBankAccount"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="enrollmentFormType.NoCreditCardOnlyBankAccount">
    <ng-container
      *ngTemplateOutlet="noCreditCardOnlyBankAccount"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="enrollmentFormType.NoCreditCard">
    <ng-container *ngTemplateOutlet="noCreditCard"></ng-container>
  </ng-container>

  <ng-container *ngSwitchCase="enrollmentFormType.CreditCardOnly">
    <ng-container *ngTemplateOutlet="creditCardOnly"></ng-container>
  </ng-container>
</ng-container>

<!--Putting templates here to make the component more readable-->
<ng-template #creditCardAndBankAccount>
  <div
    class="form-option flex w-full flex-col items-start rounded-md"
    [formGroup]="form">
    <mat-radio-group
      formControlName="selectedOption"
      class="flex w-full flex-col">
      <mat-radio-button
        [dataTestid]="'anz-rc-enrollment-radio-credit-card'"
        [value]="formOptions.CreditCard"
        class="block p-4">
        <span
          [ngClass]="{
            'font-semibold': selectedOption.value === formOptions.CreditCard
          }">
          ANZ Rewards Credit Card
        </span>
      </mat-radio-button>
      <rd-enrollment-form
        *ngIf="selectedOption.value === formOptions.CreditCard"
        formGroupName="enrollment"
        [enrollments]="enrollments$ | async"
        class="mb-5 ml-8">
      </rd-enrollment-form>
      <mat-radio-button
        [dataTestid]="'anz-rc-enrollment-radio-other-bank-account'"
        [value]="formOptions.BankAccount"
        class="cards-option relative block p-4">
        <span
          [ngClass]="{
            'font-semibold': selectedOption.value === formOptions.BankAccount
          }">
          Other ANZ Bank account
        </span>
      </mat-radio-button>
      <div
        class="ml-8 mr-4 mt-4"
        *ngIf="selectedOption.value === formOptions.BankAccount">
        <rd-anz-enrollment-link-account-detail-form
          formGroupName="accountDetails"></rd-anz-enrollment-link-account-detail-form>
      </div>
    </mat-radio-group>
  </div>
</ng-template>

<ng-template #noCreditCardOnlyBankAccount>
  <div
    class="form-option flex w-full flex-col items-start rounded-md p-4"
    [formGroup]="form">
    <h4 class="mt-0">ANZ Bank account</h4>
    <rd-anz-enrollment-link-account-detail-form
      formGroupName="accountDetails"></rd-anz-enrollment-link-account-detail-form>
  </div>
</ng-template>

<ng-template #creditCardOnly>
  <div
    class="form-option flex w-full flex-col items-start rounded-md p-4"
    [formGroup]="form"
    *ngIf="enrollments$ | async as enrollments">
    <p class="font-semibold">
      {{ enrollments[0].groupName }}
      {{ 'auto_redemption.review.credit_card' | translate }}
    </p>
    <p>{{ displayNumber(enrollments[0]) }}</p>
  </div>
</ng-template>

<ng-template #noCreditCard>
  <div
    class="form-option flex w-full flex-col items-start rounded-md p-4"
    [formGroup]="form">
    <span
      >Account/credit card details are currently unavailable. Please try again
      later.</span
    >
  </div>
</ng-template>
